import { VIRTUAL_POST_DATA } from "./types";

export const storeVirtualAdDetails = (data) => {
  return {
    type: VIRTUAL_POST_DATA,
    payload: data,
  };
};
